import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from "vue"

import InfiniteScrollSelect from "@/components/Common/InfiniteScrollSelect/index.vue"
import { fetchProductAttributes } from "@/modules/offers/api/productModeration"
import type { ProductAttributeSelectHandle } from "@/modules/offers/types/createOffer"
import type { ProductModerationAttribute } from "@/modules/offers/types/offers"

import { getAttributeLabel } from "../../utils/attributeLabels"

import AttributeInputRow from "./AttributeInputRow.vue"
import AttributeSelectRow from "./AttributeSelectRow.vue"
import CreateAttributeModal from "./CreateAttributeModal.vue"

type Props = {
  attribute: ProductModerationAttribute
  unavailableCodes: string[]
  showValidation?: boolean
}
type Emits = {
  (event: "change", attribute: ProductModerationAttribute): void
  (event: "remove"): void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FreeFormAttributeRow',
  props: {
    attribute: null,
    unavailableCodes: null,
    showValidation: { type: Boolean }
  },
  emits: ["change", "remove"],
  setup(__props: any, { emit }: { emit: ({
  (event: "change", attribute: ProductModerationAttribute): void
  (event: "remove"): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  attribute: ProductModerationAttribute
  unavailableCodes: string[]
  showValidation?: boolean
};




const attributeSelectRef = ref<ProductAttributeSelectHandle>()
const showCreateAttributeModal = ref(false)

const attributeRowComponent = computed(() =>
  props.attribute.is_defined_list ? AttributeSelectRow : AttributeInputRow
)
const valueAttribute = computed(() => ({ ...props.attribute, is_required: true }))
const showNameError = computed(() => props.showValidation && !props.attribute.code)

const selectAttribute = (code?: string) => {
  if (!code) return emit("change", { value: [] })

  const attribute = attributeSelectRef.value.selectOptions.find((item) => item.code === code)
  emit("change", { ...attribute, value: [] })
}

return { __sfc: true,props, emit, attributeSelectRef, showCreateAttributeModal, attributeRowComponent, valueAttribute, showNameError, selectAttribute, InfiniteScrollSelect, fetchProductAttributes, getAttributeLabel, CreateAttributeModal }
}

})